export const sizeTinyHeader = "S7d";
export const sizeSmallHeader = "T7d";
export const sizeMediumHeader = "U7d";
export const sizeLargeHeader = "V7d";
export const sizeVeryLargeHeader = "W7d";
export const sizeHugeHeader = "X7d";
export const sizeEnormousHeader = "Y7d";
export default {sizeTinyHeader,sizeSmallHeader,sizeMediumHeader,sizeLargeHeader,sizeVeryLargeHeader,sizeHugeHeader,sizeEnormousHeader};